import {Action} from '@ngrx/store';
import {Pruefaufgabe, Prueflauf, PrueflaufAntwort, PrueflaufAufgabe} from '../../../../clients/qschecks';


export const PAGE_STATE_RESET = '[QsChecksControllingVeranstaltungPage] Page State reset';
export const IGNORE_WS_ACTION = '[QsChecksControllingVeranstaltungPage] WS Action ignoriert';

export const VERANSTALTUNG_UEBERSICHT_NEU_LADEN = '[QsChecksControllingVeranstaltungPage] Veranstaltung Uebersicht Neu laden';
export const AKTUELLEN_PRUEFLAUF_SETZEN = '[QsChecksControllingVeranstaltungPage] Aktuellen Prueflauf setzen';
export const AKTUELLEN_PRUEFLAUF_ENTFERNEN = '[QsChecksControllingVeranstaltungPage] Prueflauf entfernen';
export const PRUEFLAUF_DETAIL_NEU_LADEN = '[QsChecksControllingVeranstaltungPage] Prueflaufdetail neu laden';

export const AKTUELLE_PRUEFAUFGABE_SETZEN = '[QsChecksControllingVeranstaltungPage] Aktuelle Prueflauf Aufgabe setzen';
export const PRUEFAUFGABE_KORRIGIEREN = '[QsChecksControllingVeranstaltungPage] Prüfaufgabe korrigieren';
export const AUFGABE_BEMERKUNG_SPEICHERN = '[QsChecksControllingVeranstaltungPage] Aufgabe Bemerkung speichern';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// IGNORE WS ACTION
export class IgnoreWSAction implements Action {
    readonly type = IGNORE_WS_ACTION;

    constructor(public payload: any) {
    }
}

export class VeranstaltungUebersichtNeuLadenAction implements Action {
    readonly type = VERANSTALTUNG_UEBERSICHT_NEU_LADEN;

    constructor() {}
}

export class AktuellenPrueflaufSetzenAction implements Action {
    readonly type = AKTUELLEN_PRUEFLAUF_SETZEN;

    constructor(public payload: Prueflauf) {}
}

export class AktuellenPrueflaufEntfernenAction implements Action {
    readonly type = AKTUELLEN_PRUEFLAUF_ENTFERNEN;

    constructor() {}
}

export class PrueflaufDetailNeuLaden implements Action {
    readonly type = PRUEFLAUF_DETAIL_NEU_LADEN;

    constructor() {}
}

export class AktuellePruefaufgabeSetzenAction implements Action {
    readonly type = AKTUELLE_PRUEFAUFGABE_SETZEN;

    constructor(public payload: PrueflaufAufgabe) {}
}

export class PruefaufgabeKorrigierenAction implements Action {
    readonly type = PRUEFAUFGABE_KORRIGIEREN;

    constructor(public aufgabe: PrueflaufAufgabe, public antwort: PrueflaufAntwort) {}
}

export class AufgabeBemerkungSpeichernAction implements Action {
    readonly type = AUFGABE_BEMERKUNG_SPEICHERN;

    constructor(public payload: string) {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    | PageStateResetAction
    | IgnoreWSAction
    | VeranstaltungUebersichtNeuLadenAction
    | AktuellenPrueflaufSetzenAction
    | AktuellenPrueflaufEntfernenAction
    | PrueflaufDetailNeuLaden
    | AktuellePruefaufgabeSetzenAction
    | PruefaufgabeKorrigierenAction
    | AufgabeBemerkungSpeichernAction
    ;
